import * as React from "react";
import * as ReactDOM from "react-dom";
import {connect} from "react-redux";
import {IPowerSource, IYear} from "../../../../data/data";
import {countPowerSourcesByID} from "../../../../store/reducers/powerSources";
import Counter from "../../../common/counter/Counter";
import {setDraggingPowerSource} from "../../../../store/actions/powerSources";
import {getYearData} from '../../../../store/reducers/year';

interface IPowerSourceProps extends IPowerSource
{
    count: number;
    year:IYear;
    setDraggingPowerSource: (power_source: IPowerSource, ox: number, oy: number) => void;
}

interface State
{
    is_max: boolean;
}

import './PowerSource.scss';

class PowerSource extends React.Component<IPowerSourceProps, State>
{
    constructor(public props: IPowerSourceProps, public state: State)
    {
        super(props);

        const {count, max} = props;

        this.state = { is_max:  count >= max };
    }


    componentDidUpdate()
    {
        const {count, max} = this.props;

        const nis_max: boolean = count >= max;

        const {is_max:ois_max} = this.state;

        if (ois_max !== nis_max) this.setState({ is_max: nis_max });
    }


    onMouseDown = (event: React.MouseEvent<HTMLElement>) =>
    {
        const {setDraggingPowerSource} = this.props;
        const {is_max} = this.state;

        if (is_max) return;

        event.preventDefault();

        setDraggingPowerSource(this.props, event.pageX, event.pageY);
    };


    isClosed = () =>
    {
        const {id, count, label, year} = this.props;
        const {is_max} = this.state;

        // console.group('isClosed');
        // console.log('id', id);
        // console.log('year', year);
        // console.log('is_closed', id === 'coal' && year.year >= 2025);
        // console.groupEnd();

        return id === 'coal' && year.year >= 2025;
    };


    /**
     * render the component
     * @returns {JSX.Element}
     */
    render() : JSX.Element
    {
        const {id, count, label, year} = this.props;
        const {is_max} = this.state;

        // console.group('render');
        // console.log('id', id);
        // console.log('label', label);
        // console.groupEnd();

        return <div
                    styleName={this.isClosed() ? 'closed' : 'power-source'}
                    onMouseDown={this.isClosed() ? null : this.onMouseDown}>

            <img
                styleName={! is_max ? 'image' : 'maxed-out'}
                src={`./img/game/power-sources/${id}@2x.png`} />

            {this.isClosed() &&
            <div styleName={'deprecated-icon'} />}

            <Counter count={is_max ? 'max' : count}/>

            <span styleName={'tooltip'}>{label}</span>

        </div>
    }
}


/**
 * map the state to props
 * @param state
 * @param props
 */
const mapStateToProps = (state, props) =>
{
    return {
        count: countPowerSourcesByID(state, props),
        year: getYearData(state),
    }
};


/**
 * map dispatch functions to the component props
 * @param dispatch
 * @returns {{onModeSelect: ((mode: string) => any); onCountrySelect: ((country: string) => any)}}
 */
const mapDispatchToProps = dispatch =>
{
    return {
        setDraggingPowerSource: (power_source: IPowerSource, ox: number, oy: number) => dispatch(setDraggingPowerSource(power_source, ox, oy))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(PowerSource);



// WEBPACK FOOTER //
// ./src/ts/app/screens/game/power-sources/PowerSource.tsx